import React from "react";
import { ViewRestrictionHistoryContainer } from "../../../containers";

const ViewRestrictionHistory = (props) => {
  return <ViewRestrictionHistoryContainer {...props} />;
};

export default ViewRestrictionHistory;
